export const css = {
    root: '_35kQ9gOs',
    banner: 'vONJGbO-',
    ' _key': 'announcements/update-banner'
};
export default css;
